import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SaveButtonColorState {
    color: string
    setColor: (color: string) => void
}

/**
 * Broadcast color change to extension (if present)
 */
function broadcastColorToExtension(color: string) {
    if (typeof window === 'undefined') return

    // Dispatch window event that content script can listen to
    window.postMessage(
        {
            type: 'SAVE_BUTTON_COLOR_UPDATED',
            color,
        },
        '*'
    )

    console.log('[PWA] Broadcasted color update to extension:', color)
}

/**
 * Store for managing user's preferred save button color
 * Persisted to localStorage for consistency across sessions
 */
export const useSaveButtonColor = create<SaveButtonColorState>()(
    persist(
        (set) => ({
            color: '#FF0000', // Default to Red
            setColor: (color) => {
                set({ color })
                // Broadcast to extension
                broadcastColorToExtension(color)
            },
        }),
        {
            name: 'save-button-color-storage',
        }
    )
)

/**
 * Listen for color requests from extension
 */
if (typeof window !== 'undefined') {
    window.addEventListener('message', (event) => {
        // Only accept messages from same origin
        if (event.source !== window) return

        const message = event.data

        // Handle request for current color
        if (message.type === 'REQUEST_SAVE_BUTTON_COLOR') {
            console.log('[PWA] Extension requested current color')

            // Get current color from store
            const currentColor = useSaveButtonColor.getState().color

            // Send response
            window.postMessage(
                {
                    type: 'SAVE_BUTTON_COLOR_RESPONSE',
                    color: currentColor,
                },
                '*'
            )

            console.log('[PWA] Sent color response to extension:', currentColor)
        }
    })
}
